const transitionDurationMs = 150;
const initialTransition = "_61icywouz";
const floatingPanel = "_61flj3w4g";
const mobileToggleDurationMs = 200;
const mobileToggle = "_61m1fotmg8";
const mobileCollapseTransition = "_61m1g203cd";
const mobileContainer = "_61m1734vzp";

export { floatingPanel, initialTransition, mobileCollapseTransition, mobileContainer, mobileToggle, mobileToggleDurationMs, transitionDurationMs };
import "./_floating-buttons.style.linaria.module.css";
//# sourceMappingURL=_floating-buttons.style.js.map
